module.exports = __webpack_public_path__ + "img/record_mode_2.cfb29df6.gif";